import type { StripeAddress } from '@inkitt/contracts-common';
import type { StripePaymentElementChangeEvent } from '@stripe/stripe-js';

/** Stripe omits the postal code for countries that do not use one (e.g. FR, PL), so country-only is complete. */
export const resolveStripeManagedAddress = (event: StripePaymentElementChangeEvent): StripeAddress | null => {
  const address = event.value.billingDetails?.address;
  const country = address?.country;

  if (!country) {
    return null;
  }

  return { country, postal_code: address?.postalCode ?? '' };
};
